import { PM25, PM10, CO, CO2, NO2, NO, SO2, O3, H2S, NH3, CH2O, SUM } from './substance.consts';

export const MMT_WITH_PDK_SORTED = [PM25, PM10, CO, CO2, NO2, NO, SO2, O3, H2S, NH3, CH2O, SUM];

export const GASES = [CO, CO2, NO2, NO, SO2, O3, H2S, NH3, CH2O];
